
export enum ReportHistoryStatusEnum {
  REQUESTED = 'REQUESTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum ReportHistoryTypeEnum {
  SELLER_LISTING = 'SELLER_LISTING',
  SELLER_ORDERS = 'SELLER_ORDERS',
  BUYER_ORDERS = 'BUYER_ORDERS',
}